import script from "./GgmsProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./GgmsProgressBar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__